import { useEffect, useState } from "react";

import type { Preset } from "simplydo/react/richtext/Remirror/types";

import Dropdown from "./Dropdown";
import useMention, { type RemirrorMention } from "./useMention";

type MentionConfigEntry = Preset[number]["config"] & { name?: string };

const mapToName = (list: Preset) =>
  list
    .filter((i) => i.name === "mention")
    .map((i) => i.config as MentionConfigEntry)
    .reduce<Record<string, MentionConfigEntry>>((p, c) => {
      if (c.name) {
        p[c.name] = c;
      }
      return p;
    }, {});

export type RemirrorMentionProps = {
  mentions: Record<string, Array<RemirrorMention>>;
  options: Preset;

  // Does not directly return mentions but just acts as a trigger to load mentions which are passed in via state
  onSuggest: (kind: Array<string>, query: string) => void;
  onMentionSelect?: (mention: RemirrorMention) => void;
};

const Mentions = ({
  mentions,
  options,
  onSuggest,
  onMentionSelect,
}: RemirrorMentionProps) => {
  const [mappedConfig, setMappedConfig] = useState<
    Record<string, MentionConfigEntry>
  >(() => mapToName(options));

  useEffect(() => {
    setMappedConfig(mapToName(options));
  }, [options]);

  const mentionProps = useMention({
    allMentions: mentions,
    config: mappedConfig,
    onSuggest,
    onMentionSelect: onMentionSelect ?? (() => {}),
  });

  return <Dropdown {...mentionProps} />;
};

export default Mentions;
